import(/* webpackMode: "eager" */ "/tmp/8de470bb10599dc/app/[locale]/error.tsx");
